import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { environment } from '../../../environments/environment';
import { AdminBooking, BookingDailyCount } from '../../model/admin.models';

@Injectable({
  providedIn: 'root'
})
export class BookingService extends BaseApiService<AdminBooking> {
  protected endpoint = '/booking';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  getDailyCounts(dateFrom: string, dateTo: string, status?: string): Observable<BookingDailyCount[]> {
    let params = new HttpParams()
      .set('dateFrom', dateFrom)
      .set('dateTo', dateTo);
    if (status) params = params.set('status', status);

    return this.http.get<BookingDailyCount[]>(
      `${environment.apiUrl}${this.endpoint}/stats/daily`,
      { params }
    );
  }
}
